// Copyright (c) 2022 by Move Closer

import { RelatedTypeDriverRegistry } from './shared'

import { ArticlesDriver, ArticlesRelatedType } from './content/related/articles'
import { ArticleFilterDriver, ArticleFilterRelatedType } from './content/related/filters'
import { AuthorDriver, AuthorRelatedType, ContentDriver, ContentRelatedType } from './content/related/content'
import { BannerDriver, BannerRelatedType } from './products/related/banner'
import { CategoryDriver, CategoryRelatedType } from './products/related/category'
import { FileDriver, FileRelatedType, GalleryDriver, GalleryRelatedType } from './media/related.types'
import { LinkDriver, LinkRelatedType, NavigationDriver, NavigationRelatedType } from './content/related/navigation'
import { ProductDriver, ProductRelatedType, ProductsDriver, ProductsRelatedType } from './products/related/product'
import { ProductFilterDriver, ProductFilterRelatedType } from './products/related/filters'
import { SnippetDriver, SnippetRelatedType } from './content/related/snippet'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const PossibleRelatedPicker = {
  ArticleFilter: ArticleFilterRelatedType,
  Articles: ArticlesRelatedType,
  Category: CategoryRelatedType,
  Content: ContentRelatedType,
  File: FileRelatedType,
  Gallery: GalleryRelatedType,
  Link: LinkRelatedType,
  Navigation: NavigationRelatedType,
  Product: ProductRelatedType,
  ProductFilter: ProductFilterRelatedType,
  Products: ProductsRelatedType,
  Snippet: SnippetRelatedType
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const PossibleRelatedType = {
  ArticleFilter: ArticleFilterRelatedType,
  Articles: ArticlesRelatedType,
  Author: AuthorRelatedType,
  Banner: BannerRelatedType,
  Category: CategoryRelatedType,
  Content: ContentRelatedType,
  File: FileRelatedType,
  Gallery: GalleryRelatedType,
  Link: LinkRelatedType,
  Navigation: NavigationRelatedType,
  Product: ProductRelatedType,
  ProductFilter: ProductFilterRelatedType,
  Products: ProductsRelatedType,
  Snippet: SnippetRelatedType
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const resolveDrivers: () => RelatedTypeDriverRegistry = () => ({
  [PossibleRelatedType.ArticleFilter]: new ArticleFilterDriver(),
  [PossibleRelatedType.Articles]: new ArticlesDriver(),
  [PossibleRelatedType.Author]: new AuthorDriver(),
  [PossibleRelatedType.Banner]: new BannerDriver(),
  [PossibleRelatedType.Category]: new CategoryDriver(),
  [PossibleRelatedType.Content]: new ContentDriver(),
  [PossibleRelatedType.File]: new FileDriver(),
  [PossibleRelatedType.Gallery]: new GalleryDriver(),
  [PossibleRelatedType.Link]: new LinkDriver(),
  [PossibleRelatedType.Navigation]: new NavigationDriver(),
  [PossibleRelatedType.Product]: new ProductDriver(),
  [PossibleRelatedType.ProductFilter]: new ProductFilterDriver(),
  [PossibleRelatedType.Products]: new ProductsDriver(),
  [PossibleRelatedType.Snippet]: new SnippetDriver()
})
